module.exports = __webpack_public_path__ + "img/sate-ayam.6297764f.jpg";